import { useEffect, useState } from 'react';
import { logoVanishesOnDark } from '../../helpers/brandColors';

// Reads the logo's pixels to tell whether it would disappear in a dark inbox. Stays false whenever
// the image cannot be read (a host without CORS taints the canvas, or no canvas at all).
const useLogoVanishesOnDark = (url) => {
  const [vanishes, setVanishes] = useState(false);

  useEffect(() => {
    setVanishes(false);
    if (!url) {
      return undefined;
    }
    let live = true;
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const size = 64;
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          return;
        }
        ctx.drawImage(img, 0, 0, size, size);
        const { data } = ctx.getImageData(0, 0, size, size);
        if (live) {
          setVanishes(logoVanishesOnDark(data));
        }
      } catch {
        // Tainted canvas: no verdict, no warning.
      }
    };
    img.src = url;
    return () => {
      live = false;
    };
  }, [url]);

  return vanishes;
};

export default useLogoVanishesOnDark;
